module.exports = __webpack_public_path__ + "static/pot4-c41349bf8d3ea9b1e5dfe83f137ed00b.svg";